import { render } from "./AustraliaDownload.vue?vue&type=template&id=73827e4b"
import script from "./AustraliaDownload.vue?vue&type=script&lang=js"
export * from "./AustraliaDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__